import { COLOR } from 'styles/styledComponents/color.model';

import * as Styled from './SectionTitle.styles';

type Props = {
  children: React.ReactNode;
  color?: COLOR;
  noMargin?: boolean;
  dividerColor?: COLOR;
  dividerMargin?: string;
  after?: React.ReactNode;
};

const SectionTitle = ({ noMargin, color, dividerColor, dividerMargin, after, children }: Props) => (
  <>
    <Styled.Container>
      <Styled.SectionTitle $color={color} $noMargin={noMargin}>
        {children}
      </Styled.SectionTitle>
      {after}
    </Styled.Container>

    <Styled.Divider $color={dividerColor} $dividerMargin={dividerMargin} />
  </>
);
export default SectionTitle;
